import React from 'react';
import styled from '@emotion/styled';
import Switch from '@mui/material/Switch';

const SwitchStyled = styled(props => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 55,
  height: 32,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 4,
    transitionDuration: '300ms',
    color: theme.colors.light.lightSteelBlue,
    '&.Mui-checked': {
      transform: 'translateX(23px)',
      color: theme.colors.orange.orange,
      '& + .MuiSwitch-track': {
        backgroundColor: theme.colors.dark.darkSlateBlue,
        border: `2px solid ${theme.colors.dark.steelBlue}`,
        opacity: 1,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 24,
    height: 24,
  },
  '& .MuiSwitch-track': {
    borderRadius: 32 / 2,
    backgroundColor: theme.colors.dark.darkSlateBlue,
    opacity: 1,
    border: `2px solid ${theme.colors.dark.steelBlue}`,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

export default SwitchStyled;
